import React from "react"
import FilterProto from "./filter-field-proto"

import {momentRange} from "../../../gd/convert/moment-range"

// @ts-ignore
import FilterFormDate from "../../../gd-app/panels/filters-panel/filter-form/date/date"

export default class FilterDateProto extends FilterProto {

    protected noDateLabel       : string
    protected showNoDateOption  : boolean

    constructor(filtersManager:any, filterConfig:any, initValue:any, label:string) {

        if (initValue && initValue.date) {
            if (typeof initValue.date === 'string') {
                initValue.date = moment(initValue.date);
            } else if (typeof initValue.date === 'object' && initValue.date.start) {

                // initValue.date.start = moment(initValue.date.start);
                // initValue.date.end = moment(initValue.date.end);
                initValue.date = momentRange(initValue.date.start, initValue.date.end);
            }
        }

        super(filtersManager, filterConfig, initValue, label);

        this.noDateLabel = 'Error';
        this.showNoDateOption = true;

        // value {
        //     noDate: true,
        //     curOption: 'before after range'
        //     date: object moment or moment range
        // }

    }

    getFilterOptions() {}

    // used only in Filter component
    getValue() {
        return this.value?this.value:{
            noDate: true,
            curOption: null
        };
    }

    setValue(val: any, silent=false) {
        this.isEnabled = true;

        if (!val || (!val.curOption && (val.noDate || !this.showNoDateOption) )) {
            val = null;
            this.isEnabled = false
        } else {
            this.isEnabled = true
        }

        super.setValue(val, silent);
    }

    optionsFillerFunc() {
        return true
    }

    render() {
        return <FilterFormDate filter={this}/>
    }
}